
module.exports = {
  name: 'shake',
  option: {
    duration: '1s',
    mode: 'both'
  },
  timeline: {
    'from, to': {
      transform: 'translate3d(0, 0, 0)'
    },
    '10%, 30%, 50%, 70%, 90%': {
      transform: 'translate3d(-10px, 0, 0)'
    },
    '20%, 40%, 60%, 80%': {
      transform: 'translate3d(10px, 0, 0)'
    }
  }
};



// WEBPACK FOOTER //
// ./lib/ctr-nodes/preset/animation/animate.css/shake.js